import { render } from "./notificationsTab.vue?vue&type=template&id=30cbad01"
import script from "./notificationsTab.vue?vue&type=script&lang=js"
export * from "./notificationsTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__